export var AppError;
(function (AppError) {
    AppError["UNKNOWN"] = "unknown_error";
    AppError["UNSUPPORTED_NETWORK"] = "unsupported_network";
    AppError["TEMPORARILY_UNAVAILABLE"] = "temporarily_unavailable";
    AppError["MISSING_NFT_COLLECTION"] = "missing_nft_collection";
})(AppError || (AppError = {}));
export var DataError;
(function (DataError) {
    DataError["UNKNOWN_DOCUMENT"] = "unknown_document";
})(DataError || (DataError = {}));
